
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "feedback-public-submission-ui",
  currentProjectVersion: "static-1.31050",
  depVersions: {
  "feedback-public-submission-ui": "static-1.31050",
  "emoji-mart": "static-3.9",
  "feedback-schema": "static-1.55638",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8535",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11983",
  "I18n": "static-7.1714",
  "quartz": "static-1.7692",
  "quartz-config": "static-1.1470",
  "quartz-core": "static-1.6911",
  "react-dlb": "static-1.96",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.86",
  "reselect": "static-3.18",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1119",
  "enviro": "static-4.523",
  "feedback-shared-ui": "static-1.55625",
  "feedback-utils": "static-1.55629",
  "forms-embed-utils-lib": "static-1.4957",
  "forms-utils-lib": "static-1.13368",
  "foundations-assets": "static-1.5385",
  "foundations-components": "static-1.8781",
  "foundations-theming": "static-1.4986",
  "hub-http": "static-1.6702",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12290",
  "icons": "static-2.708",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4242",
  "raven": "static-3.6411",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17236",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5675",
  "react-virtualized": "static-2.114",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.520",
  "tinymce-plugins": "static-1.58547",
  "transmute": "static-2.97",
  "ui-images": "static-2.1282",
  "UIComponents": "static-3.8929",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3969",
  "quartz-webpack": "static-1.3916",
  "foundations-theming-specialty": "static-1.2702",
  "property-description-translator": "static-1.4317",
  "HeadJS": "static-2.828",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3646",
  "msw": "static-1.105",
  "msw-config": "static-1.34",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4802",
  "jasmine-runner": "static-1.6949",
  "opentelemetry-fe-types": "static-1.288",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.912",
  "hubspotter-http": "static-1.4986",
  "mobile-manifest-mixins": "static-1.611",
  "module-federation": "static-1.41",
  "opentelemetry-fe": "static-1.663",
  "quartz-auth": "static-1.1367",
  "quartz-head": "static-1.1357",
  "quartz-i18n": "static-1.1367",
  "quartz-routing": "static-1.1122",
  "quartz-test": "static-1.1367",
  "quartz-tracking": "static-1.1071",
  "trellis-components": "static-1.3163",
  "ui-fonts": "static-1.1245",
  "usage-tracker-container": "static-1.7809",
  "usage-tracker-core": "static-1.7669",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.384",
  "conversations-skeleton-state": "static-1.7615",
  "reference-resolvers": "static-1.8681",
  "sanitize-text": "static-1.8654",
  "PatternValidationJS": "static-1.3379",
  "ReduxMessenger": "static-2.10867",
  "outpost": "static-1.4627",
  "rpc-client-utils": "static-1.5164",
  "sanitize": "static-1.4969",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5050",
  "floating-ui": "static-1.70",
  "hs-story-utils": "static-1.9925",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.110",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3144",
  "bend-plugin-foundations-theming": "static-1.3469",
  "foundations-theming-base": "static-1.3971",
  "stylex": "static-1.48",
  "hs-locale-management": "static-1.413",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.196",
  "web-vitals": "static-1.21",
  "ai-components-ui-library": "static-1.10061",
  "atom": "static-1.5568",
  "codemirror": "static-5.108",
  "content-assistance-lib": "static-1.8451",
  "ContentUtils": "static-1.69525",
  "data-token-picker": "static-1.17167",
  "file-manager-components": "static-1.24875",
  "FileManagerCore": "static-1.40374",
  "FileManagerLib": "static-1.40515",
  "frontend-preferences-client": "static-1.8418",
  "hub-http-contrib": "static-1.3529",
  "interframe": "static-3.5239",
  "layout-dnd-components": "static-1.13259",
  "layout-dnd-utils": "static-1.12234",
  "property-translator": "static-1.5877",
  "react-codemirror": "static-1.11139",
  "react-colorpicker": "static-2.10706",
  "reference-resolvers-lite": "static-1.8610",
  "rich-text-lib": "static-1.20588",
  "tinymce-data": "static-1.41518",
  "tinymce-themes": "static-1.57403",
  "ui-addon-emoji-picker": "static-1.10361",
  "ui-addon-sales-email": "static-1.5699",
  "ui-brand-identity-lib": "static-1.16998",
  "bender-build-tools": "static-1.3613",
  "opentelemetry-web": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.10937",
  "hubspotter-http-shared-msw-handlers": "static-1.10935",
  "usage-tracker-session-replay": "static-1.5505",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "trellis-theming": "static-1.1513",
  "tanstack-virtual": "static-1.45",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.574",
  "chirp-fetch": "static-1.2401",
  "stylex-utils": "static-1.181",
  "chatspot-core": "static-1.24002",
  "copilot-toolkit": "static-1.12189",
  "customer-data-objects-ui-components": "static-1.13532",
  "data-fetching-client": "static-1.10135",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5254",
  "ui-addon-video-player": "static-1.9121",
  "ui-coaching-tips": "static-1.29605",
  "usage-tracker": "static-1.7819",
  "cms-field-types": "static-1.5307",
  "content-icons-ui": "static-1.2478",
  "integrations-lib": "static-1.17474",
  "customer-data-objects": "static-1.8206",
  "apollo-dlb": "static-3.98",
  "apollo-link-hub-http": "static-2.5085",
  "apollo-stack-hubspot": "static-3.101",
  "breeze-engine-lib": "static-1.2250",
  "graphql": "static-1.95",
  "immer": "static-1.107",
  "immerable": "static-1.4639",
  "poll-commands": "static-1.3974",
  "ui-addon-iframeable": "static-1.9576",
  "video-components-external": "static-1.12484",
  "video-data-lib": "static-1.36142",
  "audio-components": "static-1.6602",
  "breeze-artifacts-sdk": "static-1.1057",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30091",
  "FileManagerImages": "static-1.38026",
  "foundations-components-legacy": "static-1.1806",
  "html-to-image": "static-1.67",
  "redux-toolkit": "static-1.84",
  "salesImages": "static-1.754",
  "ui-universal-auth": "static-1.9781",
  "urlinator": "static-1.5010",
  "video-components": "static-1.14486",
  "video-embed": "static-1.36976",
  "ts-schema": "static-1.4406",
  "ContentData": "static-1.69600",
  "layout-data-lib": "static-1.10559",
  "react-dnd-compat": "static-1.5108",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2046",
  "external-options-client-types": "static-1.4450",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6088",
  "hs-resources": "static-1.681",
  "inbound-db-properties-service-client": "static-1.4162",
  "NamespacedHubStyle": "static-2.9379",
  "growth-onboarding-confetti": "static-1.3555",
  "SharedI18nStrings": "static-1.190",
  "ui-addon-i18n": "static-1.11642",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5926",
  "magpie-types": "static-1.5386",
  "simple-logging-lib": "static-1.3548",
  "avatar-components": "static-1.2985",
  "customer-data-ui-utilities": "static-1.10328",
  "growth-onboarding-feedback-components": "static-1.7078",
  "flux-actions": "static-1.383",
  "hubspot-apollo-client": "static-1.5379",
  "integrations-error-boundary-lib": "static-1.14889",
  "integrations-tracking-lib": "static-1.6120",
  "laboratory-lib": "static-3.7643",
  "native-integrations-shared-strings": "static-1.8259",
  "redux-observable": "static-1.81",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10777",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1228",
  "breeze-engine-core": "static-1.1528",
  "highlight.js": "static-1.92",
  "pulse": "static-1.1146",
  "navigation-messaging": "static-1.8538",
  "content-media-composition-data-lib": "static-1.13632",
  "content-media-compositions": "static-2.17639",
  "idb-keyval": "static-1.57",
  "media-bridge-lib": "static-1.19672",
  "nudge-client-utils": "static-1.3452",
  "custom-vendor-connection-lib": "static-1.345",
  "unified-auth-core-lib": "static-1.1577",
  "social-insights-client-types": "static-1.22964",
  "advanced-menus-core": "static-1.15849",
  "advanced-menus-lib": "static-1.12594",
  "ExportDialog": "static-6.10870",
  "ui-memberships-settings-lib": "static-1.35238",
  "conditional-properties-service-client": "static-1.4125",
  "crm-pipelines-api-client-types": "static-1.4455",
  "event-emitter": "static-1.1458",
  "fdsr-migration-layer": "static-1.509",
  "framework-builder-read-service-client": "static-1.4347",
  "inbound-db-meta-service-client": "static-1.3786",
  "multi-currency-client-types": "static-1.4020",
  "foundations-components-test-utils": "static-1.6264",
  "reactive-lib": "static-1.1217",
  "trellis-migration-context": "static-1.76",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.838",
  "universal-page-editor-lib": "static-1.3510",
  "bend-plugin-pulse": "static-1.649",
  "fast-json-patch": "static-1.76",
  "nav-meta": "static-1.30848",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3209",
  "nudge-renderer-utils": "static-1.3528",
  "onboarding-tours": "static-1.17419",
  "whisper-core-api": "static-1.7671",
  "fsm": "static-1.4254",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15848",
  "simple-menus-lib": "static-1.17365",
  "settings-ui-lib": "static-1.13025",
  "persist-promise": "static-1.4203",
  "crm-record-cards-client": "static-1.100",
  "crm-record-cards-service-types": "static-1.3873",
  "framework-data-schema-resolvers": "static-1.7390",
  "location-customization-utils-lib": "static-1.10459",
  "getting-started-shared-tasks": "static-1.19600",
  "growth-data-modal": "static-1.6165",
  "growth-onboarding-next-action-utils": "static-1.3021",
  "navigation-components": "static-1.19211",
  "nest": "static-1.733",
  "onboarding-tours-client": "static-1.5634",
  "onboarding-tours-utils": "static-1.1486",
  "ui-shepherd-tracker": "static-1.8158",
  "user-context": "static-1.5551",
  "react-flip-move": "static-1.85",
  "framework-data-schema-quick-fetch": "static-1.7295",
  "onboarding-data-sync-lib": "static-1.2868",
  "growth-onboarding-next-action-components": "static-1.3049",
  "user-context-client": "static-1.5006",
  "getting-started-shared-tasks-store": "static-1.18718",
  "InboxConnectUtils": "static-4.15878",
  "meetings-connect-utils-lib": "static-1.8117",
  "onboarding-scopes": "static-1.6950"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31050",
  "emoji-mart": "/emoji-mart/static-3.9",
  "feedback-schema": "/feedback-schema/static-1.55638",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8535",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11983",
  "I18n": "/I18n/static-7.1714",
  "quartz": "/quartz/static-1.7692",
  "quartz-config": "/quartz-config/static-1.1470",
  "quartz-core": "/quartz-core/static-1.6911",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.86",
  "reselect": "/reselect/static-3.18",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1119",
  "enviro": "/enviro/static-4.523",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55625",
  "feedback-utils": "/feedback-utils/static-1.55629",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4957",
  "forms-utils-lib": "/forms-utils-lib/static-1.13368",
  "foundations-assets": "/foundations-assets/static-1.5385",
  "foundations-components": "/foundations-components/static-1.8781",
  "foundations-theming": "/foundations-theming/static-1.4986",
  "hub-http": "/hub-http/static-1.6702",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12290",
  "icons": "/icons/static-2.708",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4242",
  "raven": "/raven/static-3.6411",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17236",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5675",
  "react-virtualized": "/react-virtualized/static-2.114",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tinymce-plugins": "/tinymce-plugins/static-1.58547",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1282",
  "UIComponents": "/UIComponents/static-3.8929",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3969",
  "quartz-webpack": "/quartz-webpack/static-1.3916",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2702",
  "property-description-translator": "/property-description-translator/static-1.4317",
  "HeadJS": "/HeadJS/static-2.828",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3646",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.34",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4802",
  "jasmine-runner": "/jasmine-runner/static-1.6949",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.288",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.912",
  "hubspotter-http": "/hubspotter-http/static-1.4986",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.611",
  "module-federation": "/module-federation/static-1.41",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.663",
  "quartz-auth": "/quartz-auth/static-1.1367",
  "quartz-head": "/quartz-head/static-1.1357",
  "quartz-i18n": "/quartz-i18n/static-1.1367",
  "quartz-routing": "/quartz-routing/static-1.1122",
  "quartz-test": "/quartz-test/static-1.1367",
  "quartz-tracking": "/quartz-tracking/static-1.1071",
  "trellis-components": "/trellis-components/static-1.3163",
  "ui-fonts": "/ui-fonts/static-1.1245",
  "usage-tracker-container": "/usage-tracker-container/static-1.7809",
  "usage-tracker-core": "/usage-tracker-core/static-1.7669",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.384",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7615",
  "reference-resolvers": "/reference-resolvers/static-1.8681",
  "sanitize-text": "/sanitize-text/static-1.8654",
  "PatternValidationJS": "/PatternValidationJS/static-1.3379",
  "ReduxMessenger": "/ReduxMessenger/static-2.10867",
  "outpost": "/outpost/static-1.4627",
  "rpc-client-utils": "/rpc-client-utils/static-1.5164",
  "sanitize": "/sanitize/static-1.4969",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5050",
  "floating-ui": "/floating-ui/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9925",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.110",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3144",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3469",
  "foundations-theming-base": "/foundations-theming-base/static-1.3971",
  "stylex": "/stylex/static-1.48",
  "hs-locale-management": "/hs-locale-management/static-1.413",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.196",
  "web-vitals": "/web-vitals/static-1.21",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10061",
  "atom": "/atom/static-1.5568",
  "codemirror": "/codemirror/static-5.108",
  "content-assistance-lib": "/content-assistance-lib/static-1.8451",
  "ContentUtils": "/ContentUtils/static-1.69525",
  "data-token-picker": "/data-token-picker/static-1.17167",
  "file-manager-components": "/file-manager-components/static-1.24875",
  "FileManagerCore": "/FileManagerCore/static-1.40374",
  "FileManagerLib": "/FileManagerLib/static-1.40515",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8418",
  "hub-http-contrib": "/hub-http-contrib/static-1.3529",
  "interframe": "/interframe/static-3.5239",
  "layout-dnd-components": "/layout-dnd-components/static-1.13259",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12234",
  "property-translator": "/property-translator/static-1.5877",
  "react-codemirror": "/react-codemirror/static-1.11139",
  "react-colorpicker": "/react-colorpicker/static-2.10706",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8610",
  "rich-text-lib": "/rich-text-lib/static-1.20588",
  "tinymce-data": "/tinymce-data/static-1.41518",
  "tinymce-themes": "/tinymce-themes/static-1.57403",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10361",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5699",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16998",
  "bender-build-tools": "/bender-build-tools/static-1.3613",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10937",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10935",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5505",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "trellis-theming": "/trellis-theming/static-1.1513",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.574",
  "chirp-fetch": "/chirp-fetch/static-1.2401",
  "stylex-utils": "/stylex-utils/static-1.181",
  "chatspot-core": "/chatspot-core/static-1.24002",
  "copilot-toolkit": "/copilot-toolkit/static-1.12189",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13532",
  "data-fetching-client": "/data-fetching-client/static-1.10135",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5254",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9121",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29605",
  "usage-tracker": "/usage-tracker/static-1.7819",
  "cms-field-types": "/cms-field-types/static-1.5307",
  "content-icons-ui": "/content-icons-ui/static-1.2478",
  "integrations-lib": "/integrations-lib/static-1.17474",
  "customer-data-objects": "/customer-data-objects/static-1.8206",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5085",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2250",
  "graphql": "/graphql/static-1.95",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4639",
  "poll-commands": "/poll-commands/static-1.3974",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9576",
  "video-components-external": "/video-components-external/static-1.12484",
  "video-data-lib": "/video-data-lib/static-1.36142",
  "audio-components": "/audio-components/static-1.6602",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1057",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30091",
  "FileManagerImages": "/FileManagerImages/static-1.38026",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1806",
  "html-to-image": "/html-to-image/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "salesImages": "/salesImages/static-1.754",
  "ui-universal-auth": "/ui-universal-auth/static-1.9781",
  "urlinator": "/urlinator/static-1.5010",
  "video-components": "/video-components/static-1.14486",
  "video-embed": "/video-embed/static-1.36976",
  "ts-schema": "/ts-schema/static-1.4406",
  "ContentData": "/ContentData/static-1.69600",
  "layout-data-lib": "/layout-data-lib/static-1.10559",
  "react-dnd-compat": "/react-dnd-compat/static-1.5108",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2046",
  "external-options-client-types": "/external-options-client-types/static-1.4450",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6088",
  "hs-resources": "/hs-resources/static-1.681",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4162",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9379",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3555",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11642",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5926",
  "magpie-types": "/magpie-types/static-1.5386",
  "simple-logging-lib": "/simple-logging-lib/static-1.3548",
  "avatar-components": "/avatar-components/static-1.2985",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10328",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7078",
  "flux-actions": "/flux-actions/static-1.383",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5379",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14889",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6120",
  "laboratory-lib": "/laboratory-lib/static-3.7643",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8259",
  "redux-observable": "/redux-observable/static-1.81",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10777",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1228",
  "breeze-engine-core": "/breeze-engine-core/static-1.1528",
  "highlight.js": "/highlight.js/static-1.92",
  "pulse": "/pulse/static-1.1146",
  "navigation-messaging": "/navigation-messaging/static-1.8538",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13632",
  "content-media-compositions": "/content-media-compositions/static-2.17639",
  "idb-keyval": "/idb-keyval/static-1.57",
  "media-bridge-lib": "/media-bridge-lib/static-1.19672",
  "nudge-client-utils": "/nudge-client-utils/static-1.3452",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.345",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1577",
  "social-insights-client-types": "/social-insights-client-types/static-1.22964",
  "advanced-menus-core": "/advanced-menus-core/static-1.15849",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12594",
  "ExportDialog": "/ExportDialog/static-6.10870",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35238",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4125",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4455",
  "event-emitter": "/event-emitter/static-1.1458",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.509",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4347",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3786",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4020",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6264",
  "reactive-lib": "/reactive-lib/static-1.1217",
  "trellis-migration-context": "/trellis-migration-context/static-1.76",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.838",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3510",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.649",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "nav-meta": "/nav-meta/static-1.30848",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3209",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3528",
  "onboarding-tours": "/onboarding-tours/static-1.17419",
  "whisper-core-api": "/whisper-core-api/static-1.7671",
  "fsm": "/fsm/static-1.4254",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15848",
  "simple-menus-lib": "/simple-menus-lib/static-1.17365",
  "settings-ui-lib": "/settings-ui-lib/static-1.13025",
  "persist-promise": "/persist-promise/static-1.4203",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.100",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3873",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7390",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10459",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19600",
  "growth-data-modal": "/growth-data-modal/static-1.6165",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3021",
  "navigation-components": "/navigation-components/static-1.19211",
  "nest": "/nest/static-1.733",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5634",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1486",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8158",
  "user-context": "/user-context/static-1.5551",
  "react-flip-move": "/react-flip-move/static-1.85",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7295",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2868",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3049",
  "user-context-client": "/user-context-client/static-1.5006",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18718",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15878",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8117",
  "onboarding-scopes": "/onboarding-scopes/static-1.6950"
}
};
